import type { WriteResult } from "@/api/client";
import type { ConfirmRefusal } from "@/components/ConfirmDialog";
import type { TemplateRef } from "@shared/dto";

type RefusalCopy = {
  inUse: (templates: readonly TemplateRef[]) => string;
  missing: string;
  // Skills and traits archive, topics deactivate, so only the wording differs.
  stillActive: string;
};

// Skills, traits and topics refuse deletion for the same three reasons. The
// query used to hand back a tagged reason; over the wire it is the problem
// type, so the mapping back into dialog copy lives once.
export const refusalFrom = (
  result: WriteResult<unknown>,
  copy: RefusalCopy,
): ConfirmRefusal => {
  if (result.isOk) {
    return null;
  }

  const slug = result.problem.type.replace("/problems/", "");

  if (slug === "in-use") {
    return { refusal: copy.inUse(result.problem.templates ?? []) };
  }

  return {
    refusal: slug === "not-found" ? copy.missing : copy.stillActive,
  };
};
